module.exports = __webpack_public_path__ + "img/ic-download.653c7200.svg";